module.exports = __webpack_public_path__ + "static/media/zm.acad9df9.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/zm.svg
// module id = 803
// module chunks = 0